import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { View } from '@amzn/stencil-react-components/layout';

/**
 * A styled View component with configurable borders
 */
const BorderedView = styled(View)(({ borderColor, borderWidth, borderStyle }) => ({
  border: [borderWidth, borderStyle, borderColor].join(' '),
}));

BorderedView.propTypes = {
  ...View.propTypes,
  isActive: PropTypes.bool,
};

BorderedView.defaultProps = {
  borderColor: '',
  borderWidth: '',
  borderStyle: '',
  backgroundColor: '#F0F1F2',
  padding: '10px 16px',
};

export default BorderedView;
